module.exports = __webpack_public_path__ + "static/media/down-arrow-blue.8b0278fe.svg";